module.exports = __webpack_public_path__ + "static/scale-model-of-2nd-avenue-historic-district-in-nashville-tennessee-04a3aee7b32d67f59062ef79abd1ac07.png";